import { getDataAll as apiGetDataAll } from 'api/Api'
import {
  addCardRelations
} from 'store/redux/cardRelations'

type Payload = {
  cardIds: number[];
}

const fetchCardRelations = (payload: Payload) => async dispatch => {
  const { cardIds } = payload

  const [
    { Cards: CardsChildren },
    { Cards: CardsSequences }
  ] = await apiGetDataAll([
    { method: 'CardsChildren', args: { cardIds } },
    { method: 'CardsSequences', args: { cardIds } }
  ])

  const cardRelationsById =
    CardsChildren.concat(CardsSequences)
      .reduce((cardRelations, CardRelation) => {
        let cardRelation = cardRelations[CardRelation.Id]

        if (!cardRelation) {
          cardRelations[CardRelation.Id] = {
            id: CardRelation.Id
          }

          cardRelation = cardRelations[CardRelation.Id]
        }
        
        if (CardRelation.DefaultParentId) cardRelation.defaultParentId = CardRelation.DefaultParentId
        if (CardRelation.ParentIds) cardRelation.parentIds = CardRelation.ParentIds
        if (CardRelation.ChildIds) cardRelation.childIds = CardRelation.ChildIds
        if (CardRelation.PredIds) cardRelation.predecessorIds = CardRelation.PredIds
        if (CardRelation.SuccIds) cardRelation.successorIds = CardRelation.SuccIds

        return cardRelations
      }, {})

  dispatch(addCardRelations(Object.keys(cardRelationsById).map(key => cardRelationsById[key])))
}

export default fetchCardRelations
